(function () {
  'use strict';

  function initCollection(root) {
    if (!root || root.dataset.wevoltCollectionInit === 'true') return;
    root.dataset.wevoltCollectionInit = 'true';

    initFilterDrawer(root);
    initGridToggle(root);
    initLoadMore(root);
    initAjaxFacets(root);
  }

  function initFilterDrawer(root) {
    var shell = root.querySelector('[data-wevolt-facets-drawer]');
    if (!shell) return;

    var openBtn = root.querySelector('[data-wevolt-filter-open]');
    var closeEls = shell.querySelectorAll('[data-wevolt-filter-close]');
    var applyBtn = shell.querySelector('[data-wevolt-filter-apply]');
    var overlay = shell.querySelector('.wevolt-collection__facets-drawer-overlay');

    function openDrawer() {
      shell.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('wevolt-scroll-lock');
    }

    function closeDrawer() {
      shell.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('wevolt-scroll-lock');
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var form = shell.querySelector('[data-wevolt-facet-form]');
        if (form) {
          ajaxCollectionUpdate(root, buildFacetUrl(form, root));
          closeDrawer();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && shell.classList.contains('is-open')) closeDrawer();
    });
  }

  function buildFacetUrl(form, root) {
    var sectionId = root.dataset.sectionId;
    var params = new URLSearchParams(new FormData(form));
    if (sectionId) params.set('section_id', sectionId);
    var base = form.action || root.dataset.collectionUrl || window.location.pathname;
    return base + '?' + params.toString();
  }

  function buildUrlFromHref(href, root) {
    var url = new URL(href, window.location.origin);
    var sectionId = root.dataset.sectionId;
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function ajaxCollectionUpdate(root, fetchUrl, pushUrl) {
    root.classList.add('is-updating');

    return fetch(fetchUrl)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newRoot = doc.querySelector('[data-wevolt-collection]');
        if (!newRoot) return;

        var results = root.querySelector('[data-wevolt-collection-results]');
        var newResults = newRoot.querySelector('[data-wevolt-collection-results]');
        if (results && newResults) results.innerHTML = newResults.innerHTML;

        var facets = root.querySelector('.wevolt-collection__facets');
        var newFacets = newRoot.querySelector('.wevolt-collection__facets');
        if (facets && newFacets) facets.innerHTML = newFacets.innerHTML;

        var count = root.querySelector('[data-testid="products-count"]');
        var newCount = newRoot.querySelector('[data-testid="products-count"]');
        if (count && newCount) count.innerHTML = newCount.innerHTML;

        var applyBtn = root.querySelector('[data-wevolt-filter-apply]');
        var newApplyBtn = newRoot.querySelector('[data-wevolt-filter-apply]');
        if (applyBtn && newApplyBtn) applyBtn.textContent = newApplyBtn.textContent;

        var grid = root.querySelector('[data-wevolt-product-grid]');
        if (grid && window.bootWevoltProductCards) window.bootWevoltProductCards(grid);

        if (pushUrl !== false) {
          var displayUrl = pushUrl || fetchUrl.replace(/([?&])section_id=[^&]+&?/, '$1').replace(/[?&]$/, '');
          window.history.pushState({ wevoltCollection: true }, '', displayUrl);
        }
      })
      .finally(function () {
        root.classList.remove('is-updating');
      });
  }

  function initAjaxFacets(root) {
    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-wevolt-facet-form]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      ajaxCollectionUpdate(root, buildFacetUrl(form, root));
    });

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!root.contains(input)) return;

      if (input.matches('[data-wevolt-sort]')) {
        var form = root.querySelector('[data-wevolt-facet-form]');
        if (form) {
          ajaxCollectionUpdate(root, buildFacetUrl(form, root));
        }
        return;
      }

      if (input.matches('[data-wevolt-facet-input]') && window.matchMedia('(min-width: 990px)').matches) {
        var facetForm = input.closest('[data-wevolt-facet-form]');
        if (facetForm) ajaxCollectionUpdate(root, buildFacetUrl(facetForm, root));
      }
    });

    root.addEventListener('click', function (event) {
      var link = event.target.closest(
        '.wevolt-collection__active-pill, .wevolt-collection__clear-all, .wevolt-collection__pagination-link, .wevolt-collection__pagination a'
      );
      if (!link || !root.contains(link)) return;
      event.preventDefault();
      ajaxCollectionUpdate(root, buildUrlFromHref(link.href, root));
    });

    window.addEventListener('popstate', function () {
      if (window.location.pathname.indexOf('/collections/') !== -1) {
        var sectionId = root.dataset.sectionId;
        var url = window.location.href;
        if (sectionId && url.indexOf('section_id=') === -1) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
        }
        ajaxCollectionUpdate(root, url, false);
      }
    });
  }

  function initGridToggle(root) {
    var grid = root.querySelector('[data-wevolt-product-grid]');
    if (!grid) return;

    root.querySelectorAll('[data-wevolt-grid-layout]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        grid.classList.toggle('is-compact', input.value === 'compact');
      });
    });
  }

  function initLoadMore(root) {
    var btn = root.querySelector('[data-wevolt-load-more]');
    if (!btn) return;

    var grid = root.querySelector('[data-wevolt-product-grid]');
    var wrap = root.querySelector('[data-wevolt-load-more-wrap]');
    var message = root.querySelector('[data-wevolt-load-more-message]');

    btn.addEventListener('click', function () {
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      if (message) message.textContent = '';

      fetch(nextUrl)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-wevolt-product-grid]');
          var newBtn = doc.querySelector('[data-wevolt-load-more]');

          if (newGrid && grid) {
            newGrid.querySelectorAll('li').forEach(function (item) {
              grid.appendChild(item);
            });
            if (window.bootWevoltProductCards) window.bootWevoltProductCards(grid);
          }

          if (newBtn && btn) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl || '';
            if (!newBtn.dataset.nextUrl && wrap) wrap.remove();
          } else if (wrap) {
            wrap.remove();
          }
        })
        .catch(function () {
          if (message) message.textContent = 'Error loading products';
        })
        .finally(function () {
          btn.classList.remove('is-loading');
        });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wevolt-collection]').forEach(initCollection);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
